import { useState } from "react";

// react-bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

//api calls
import { useExperimentEdit, useSampleEdit } from "../api/posts";

export default function Notes({ savedNotes, id, type }) {
  const [notes, setNotes] = useState(savedNotes);
  const [isSaved, setIsSaved] = useState(savedNotes || notes ? true : false);

  const {
    mutateAsync: editSample,
    isSuccess: editSampleSuccess,
    isError: editSampleError,
    isLoading: editSampleLoading,
  } = useSampleEdit(id);

  const {
    mutateAsync: editExperiment,
    isSuccess: editExperimentSuccess,
    isError: editExperimentError,
    isLoading: editExperimentLoading,
  } = useExperimentEdit(id);

  async function handleNotesSave() {
    if (notes !== savedNotes) {
      if (type === "sample") {
        await editSample({ id: id, data: { notes: notes } });
      } else if (type === "experiment") {
        await editExperiment({ id: id, data: { notes: notes } });
      }
    }
    setIsSaved(notes ? true : false);
  }
  return (
    <Form>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <Form.Label className='h5 card-title text-primary'>Notes</Form.Label>
        {/* if the notes are saved, show the edit button, else show the save button */}
        {isSaved ? (
          <Button
            variant='secondary'
            type='submit'
            onClick={(e) => {
              e.preventDefault();
              setIsSaved(false);
            }}
          >
            Edit
          </Button>
        ) : (
          <Button
            variant='outline-primary'
            type='submit'
            disabled={editSampleLoading || editExperimentLoading}
            onClick={(e) => {
              e.preventDefault();
              handleNotesSave();
            }}
          >
            {editSampleLoading || editExperimentLoading ? "Saving..." : "Save"}
          </Button>
        )}
      </div>

      <Form.Control
        as={"textarea"}
        rows={6}
        placeholder='Enter notes here'
        defaultValue={savedNotes}
        disabled={isSaved}
        style={{ opacity: `${isSaved ? "0.7" : ""}` }}
        onChange={(e) => setNotes(e.target.value)}
      />
    </Form>
  );
}
